export default "__VITE_ASSET__DAgI1LAq__"